import { render, staticRenderFns } from "./CompanyDetails.vue?vue&type=template&id=1a1e0095&scoped=true"
import script from "./CompanyDetails.vue?vue&type=script&lang=js"
export * from "./CompanyDetails.vue?vue&type=script&lang=js"
import style0 from "./CompanyDetails.vue?vue&type=style&index=0&id=1a1e0095&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1e0095",
  null
  
)

export default component.exports